
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tennis/country/[countrySlug]",
      function () {
        return require("private-next-pages/tennis/country/[countrySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tennis/country/[countrySlug]"])
      });
    }
  